import { Text as ChakraText, TextProps } from "@chakra-ui/react";
import { FC } from "react";

export { Heading } from "@chakra-ui/react";

export const Text: FC<TextProps> = ({
  as = "span",
  fontFamily = "Inter",
  ...restProps
}) => <ChakraText {...restProps} as={as} fontFamily={fontFamily} />;
